import type { Dict } from "./types";

export const auth: Dict = {
  "login.title": {
    tr: "Giriş",
    en: "Log in",
    de: "Anmelden",
    fr: "Connexion",
    ar: "تسجيل الدخول",
    es: "Iniciar sesión",
  },
  "login.subtitle": {
    tr: "JUËN üyeliğinize giriş yapın",
    en: "Log in to your JUËN membership",
    de: "Melde dich bei deiner JUËN-Mitgliedschaft an",
    fr: "Connectez-vous à votre adhésion JUËN",
    ar: "سجل الدخول إلى عضوية JUËN الخاصة بك",
    es: "Inicia sesión en tu membresía JUËN",
  },
  "login.emailOrUser": {
    tr: "E-posta veya kullanıcı adı",
    en: "Email or username",
    de: "E-Mail oder Benutzername",
    fr: "E-mail ou nom d'utilisateur",
    ar: "البريد الإلكتروني أو اسم المستخدم",
    es: "Correo electrónico o nombre de usuario",
  },
  "login.password": {
    tr: "Şifre",
    en: "Password",
    de: "Passwort",
    fr: "Mot de passe",
    ar: "كلمة المرور",
    es: "Contraseña",
  },
  "login.remember": {
    tr: "Beni hatırla",
    en: "Remember me",
    de: "Angemeldet bleiben",
    fr: "Se souvenir de moi",
    ar: "تذكرني",
    es: "Recordarme",
  },
  "login.forgot": {
    tr: "Şifremi unuttum",
    en: "Forgot password",
    de: "Passwort vergessen",
    fr: "Mot de passe oublié",
    ar: "نسيت كلمة المرور",
    es: "¿Olvidaste tu contraseña?",
  },
  "login.submitting": {
    tr: "Giriş yapılıyor...",
    en: "Logging in...",
    de: "Anmeldung läuft...",
    fr: "Connexion en cours...",
    ar: "جارٍ تسجيل الدخول...",
    es: "Iniciando sesión...",
  },
  "login.submit": {
    tr: "Giriş yap",
    en: "Log in",
    de: "Anmelden",
    fr: "Se connecter",
    ar: "تسجيل الدخول",
    es: "Iniciar sesión",
  },
  "login.noAccount": {
    tr: "Henüz üye değil misiniz?",
    en: "Not a member yet?",
    de: "Noch kein Mitglied?",
    fr: "Pas encore membre ?",
    ar: "ألا تملك عضوية بعد؟",
    es: "¿Aún no eres miembro?",
  },
  "login.applyLink": {
    tr: "Üyelik başvurusu",
    en: "Apply for membership",
    de: "Mitgliedschaft beantragen",
    fr: "Demande d'adhésion",
    ar: "طلب العضوية",
    es: "Solicitar membresía",
  },
  "login.welcome": {
    tr: "Hoş geldiniz!",
    en: "Welcome!",
    de: "Willkommen!",
    fr: "Bienvenue !",
    ar: "أهلاً بك!",
    es: "¡Bienvenido!",
  },
  "forgot.title": {
    tr: "Şifremi Unuttum",
    en: "Forgot Password",
    de: "Passwort vergessen",
    fr: "Mot de passe oublié",
    ar: "نسيت كلمة المرور",
    es: "¿Olvidaste la contraseña?",
  },
  "forgot.subtitle": {
    tr: "E-posta adresinizi girin, şifre sıfırlama bağlantısı gönderelim.",
    en: "Enter your email and we'll send you a password reset link.",
    de: "Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.",
    fr: "Entrez votre adresse e-mail, nous vous enverrons un lien de réinitialisation de mot de passe.",
    ar: "أدخل عنوان بريدك الإلكتروني، وسنرسل لك رابط إعادة تعيين كلمة المرور.",
    es: "Introduce tu correo electrónico y te enviaremos un enlace para restablecer la contraseña.",
  },
  "forgot.email": {
    tr: "E-posta",
    en: "Email",
    de: "E-Mail",
    fr: "E-mail",
    ar: "البريد الإلكتروني",
    es: "Correo electrónico",
  },
  "forgot.sending": {
    tr: "Gönderiliyor...",
    en: "Sending...",
    de: "Wird gesendet...",
    fr: "Envoi en cours...",
    ar: "جارٍ الإرسال...",
    es: "Enviando...",
  },
  "forgot.submit": {
    tr: "Sıfırlama bağlantısı gönder",
    en: "Send reset link",
    de: "Link zum Zurücksetzen senden",
    fr: "Envoyer le lien de réinitialisation",
    ar: "إرسال رابط إعادة التعيين",
    es: "Enviar enlace de restablecimiento",
  },
  "forgot.sentToast": {
    tr: "Sıfırlama bağlantısı e-postanıza gönderildi",
    en: "Reset link sent to your email",
    de: "Link zum Zurücksetzen wurde an deine E-Mail gesendet",
    fr: "Le lien de réinitialisation a été envoyé à votre e-mail",
    ar: "تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني",
    es: "Enlace de restablecimiento enviado a tu correo electrónico",
  },
  "forgot.sentBody": {
    tr: "adresine sıfırlama bağlantısı gönderildi. Gelen kutunuzu (ve spam klasörünüzü) kontrol edin.",
    en: "we sent a reset link to this address. Please check your inbox (and spam folder).",
    de: "wir haben einen Link an diese Adresse gesendet. Prüfe dein Postfach (und den Spam-Ordner).",
    fr: "Le lien de réinitialisation a été envoyé à votre adresse. Vérifiez votre boîte de réception (et votre dossier de spams).",
    ar: "تم إرسال رابط إعادة التعيين إلى {email_address}. يرجى التحقق من صندوق الوارد (ومجلد البريد العشوائي).",
    es: "hemos enviado un enlace de restablecimiento a esta dirección. Por favor, revisa tu bandeja de entrada (y la carpeta de spam).",
  },
  "forgot.backToLogin": {
    tr: "Girişe dön",
    en: "Back to login",
    de: "Zurück zur Anmeldung",
    fr: "Retour à la connexion",
    ar: "العودة إلى تسجيل الدخول",
    es: "Volver al inicio de sesión",
  },
  "reset.title": {
    tr: "Yeni Şifre Belirle",
    en: "Set a New Password",
    de: "Neues Passwort festlegen",
    fr: "Définir un nouveau mot de passe",
    ar: "تعيين كلمة مرور جديدة",
    es: "Establecer una nueva contraseña",
  },
  "reset.subtitle": {
    tr: "Hesabınız için yeni bir şifre belirleyin.",
    en: "Choose a new password for your account.",
    de: "Wähle ein neues Passwort für dein Konto.",
    fr: "Définissez un nouveau mot de passe pour votre compte.",
    ar: "عيّن كلمة مرور جديدة لحسابك.",
    es: "Elige una nueva contraseña para tu cuenta.",
  },
  "reset.verifying": {
    tr: "Sıfırlama bağlantınız doğrulanıyor... E-postanızdaki bağlantıdan geldiğinizden emin olun.",
    en: "Verifying your reset link... Make sure you arrived via the link in your email.",
    de: "Dein Link wird geprüft... Stelle sicher, dass du über den Link in deiner E-Mail hierher gekommen bist.",
    fr: "Vérification de votre lien de réinitialisation... Assurez-vous d'être venu du lien dans votre e-mail.",
    ar: "جارٍ التحقق من رابط إعادة التعيين... تأكد أنك أتيت من الرابط في بريدك الإلكتروني.",
    es: "Verificando tu enlace de restablecimiento... Asegúrate de haber llegado a través del enlace de tu correo electrónico.",
  },
  "reset.new": {
    tr: "Yeni Şifre",
    en: "New password",
    de: "Neues Passwort",
    fr: "Nouveau mot de passe",
    ar: "كلمة المرور الجديدة",
    es: "Nueva contraseña",
  },
  "reset.confirm": {
    tr: "Yeni Şifre (Tekrar)",
    en: "New password (repeat)",
    de: "Neues Passwort (wiederholen)",
    fr: "Nouveau mot de passe (répéter)",
    ar: "كلمة المرور الجديدة (مرة أخرى)",
    es: "Nueva contraseña (repetir)",
  },
  "reset.updating": {
    tr: "Güncelleniyor...",
    en: "Updating...",
    de: "Wird aktualisiert...",
    fr: "Mise à jour en cours...",
    ar: "جارٍ التحديث...",
    es: "Actualizando...",
  },
  "reset.submit": {
    tr: "Şifreyi güncelle",
    en: "Update password",
    de: "Passwort aktualisieren",
    fr: "Mettre à jour le mot de passe",
    ar: "تحديث كلمة المرور",
    es: "Actualizar contraseña",
  },
  "reset.tooShort": {
    tr: "Şifre en az 6 karakter olmalı",
    en: "Password must be at least 6 characters",
    de: "Das Passwort muss mindestens 6 Zeichen haben",
    fr: "Le mot de passe doit contenir au moins 6 caractères",
    ar: "يجب ألا تقل كلمة المرور عن 6 أحرف",
    es: "La contraseña debe tener al menos 6 caracteres",
  },
  "reset.mismatch": {
    tr: "Şifreler eşleşmiyor",
    en: "Passwords don't match",
    de: "Passwörter stimmen nicht überein",
    fr: "Les mots de passe ne correspondent pas",
    ar: "كلمات المرور غير متطابقة",
    es: "Las contraseñas no coinciden",
  },
  "reset.done": {
    tr: "Şifreniz güncellendi",
    en: "Your password has been updated",
    de: "Dein Passwort wurde aktualisiert",
    fr: "Votre mot de passe a été mis à jour",
    ar: "تم تحديث كلمة المرور الخاصة بك",
    es: "Tu contraseña ha sido actualizada",
  },
  "signup.title": {
    tr: "Üyelik Başvurusu",
    en: "Membership Application",
    de: "Mitgliedsantrag",
    fr: "Demande d'adhésion",
    ar: "طلب العضوية",
    es: "Solicitud de membresía",
  },
  "signup.subtitle": {
    tr: "Bilgileriniz incelendikten sonra üyeliğiniz onaylanacaktır.",
    en: "Your membership will be approved after we review your details.",
    de: "Deine Mitgliedschaft wird nach Prüfung deiner Angaben freigegeben.",
    fr: "Votre adhésion sera approuvée après examen de vos informations.",
    ar: "ستتم الموافقة على عضويتك بعد مراجعة معلوماتك.",
    es: "Your membership will be approved after we review your details.",
  },
  "signup.firstName": {
    tr: "Ad",
    en: "First name",
    de: "Vorname",
    fr: "Nom",
    ar: "الاسم",
    es: "First name",
  },
  "signup.lastName": {
    tr: "Soyad",
    en: "Last name",
    de: "Nachname",
    fr: "Prénom",
    ar: "الكنية",
    es: "Last name",
  },
  "signup.email": {
    tr: "E-posta",
    en: "Email",
    de: "E-Mail",
    fr: "E-mail",
    ar: "البريد الإلكتروني",
    es: "Email",
  },
  "signup.password": {
    tr: "Şifre",
    en: "Password",
    de: "Passwort",
    fr: "Mot de passe",
    ar: "كلمة المرور",
    es: "Password",
  },
  "signup.passwordHint": {
    tr: "En az 6 karakter",
    en: "At least 6 characters",
    de: "Mindestens 6 Zeichen",
    fr: "Au moins 6 caractères",
    ar: "على الأقل 6 أحرف",
    es: "At least 6 characters",
  },
  "signup.phone": {
    tr: "Telefon",
    en: "Phone",
    de: "Telefon",
    fr: "Téléphone",
    ar: "الهاتف",
    es: "Phone",
  },
  "signup.birthDate": {
    tr: "Doğum tarihi",
    en: "Date of birth",
    de: "Geburtsdatum",
    fr: "Date de naissance",
    ar: "تاريخ الميلاد",
    es: "Date of birth",
  },
  "signup.city": {
    tr: "Şehir",
    en: "City",
    de: "Stadt",
    fr: "Ville",
    ar: "المدينة",
    es: "City",
  },
  "signup.instagram": {
    tr: "Instagram",
    en: "Instagram",
    de: "Instagram",
    fr: "Instagram",
    ar: "Instagram",
    es: "Instagram",
  },
  "signup.instagramPlaceholder": {
    tr: "@kullaniciadi",
    en: "@username",
    de: "@benutzername",
    fr: "@nomdutilisateur",
    ar: "@اسم_المستخدم",
    es: "@username",
  },
  "signup.gender": {
    tr: "Cinsiyet",
    en: "Gender",
    de: "Geschlecht",
    fr: "Sexe",
    ar: "الجنس",
    es: "Gender",
  },
  "signup.female": {
    tr: "Kadın",
    en: "Female",
    de: "Weiblich",
    fr: "Femme",
    ar: "أنثى",
    es: "Female",
  },
  "signup.male": {
    tr: "Erkek",
    en: "Male",
    de: "Männlich",
    fr: "Homme",
    ar: "ذكر",
    es: "Male",
  },
  "signup.sending": {
    tr: "Gönderiliyor...",
    en: "Submitting...",
    de: "Wird gesendet...",
    fr: "Envoi...",
    ar: "جارٍ الإرسال...",
    es: "Submitting...",
  },
  "signup.submit": {
    tr: "Başvuruyu gönder",
    en: "Submit application",
    de: "Antrag senden",
    fr: "Envoyer la candidature",
    ar: "إرسال الطلب",
    es: "Submit application",
  },
  "signup.haveAccount": {
    tr: "Zaten üye misiniz?",
    en: "Already a member?",
    de: "Schon Mitglied?",
    fr: "Déjà membre ?",
    ar: "هل أنت عضو بالفعل؟",
    es: "Already a member?",
  },
  "signup.loginLink": {
    tr: "Giriş yapın",
    en: "Log in",
    de: "Anmelden",
    fr: "Connectez-vous",
    ar: "تسجيل الدخول",
    es: "Log in",
  },
  "signup.legalRequired": {
    tr: "Devam etmek için yasal metinleri onaylayın",
    en: "Please accept the legal terms to continue",
    de: "Bitte akzeptiere die rechtlichen Hinweise, um fortzufahren",
    fr: "Veuillez accepter les textes légaux pour continuer",
    ar: "يرجى الموافقة على النصوص القانونية للمتابعة",
    es: "Please accept the legal terms to continue",
  },
  "signup.checkFields": {
    tr: "Lütfen bilgileri kontrol edin",
    en: "Please check your details",
    de: "Bitte überprüfe deine Angaben",
    fr: "Veuillez vérifier les informations",
    ar: "يرجى التحقق من المعلومات",
    es: "Please check your details",
  },
  "signup.received": {
    tr: "Başvurunuz alındı! İncelendikten sonra haberdar olacaksınız.",
    en: "Application received! We'll let you know once it's reviewed.",
    de: "Antrag erhalten! Wir melden uns nach der Prüfung bei dir.",
    fr: "Votre candidature a été reçue ! Vous serez informé après examen.",
    ar: "تم استلام طلبك! سيتم إبلاغك بعد المراجعة.",
    es: "Application received! We'll let you know once it's reviewed.",
  },
  "legal.pre": {
    tr: "Ön Bilgilendirme Formu",
    en: "Pre-Information Form",
    de: "Vorabinformationsformular",
    fr: "Formulaire d'information préalable",
    ar: "نموذج المعلومات الأولية",
    es: "Pre-Information Form",
  },
  "legal.distance": {
    tr: "Mesafeli Satış Sözleşmesi",
    en: "Distance Sales Agreement",
    de: "Fernabsatzvertrag",
    fr: "Contrat de vente à distance",
    ar: "عقد البيع عن بعد",
    es: "Distance Sales Agreement",
  },
  "legal.refund": {
    tr: "İade & İptal Politikası",
    en: "Refund & Cancellation Policy",
    de: "Rückgabe- & Stornobedingungen",
    fr: "Politique de retour et d'annulation",
    ar: "سياسة الإرجاع والإلغاء",
    es: "Refund & Cancellation Policy",
  },
  "legal.consentPrefix": {
    tr: "",
    en: "I have read, understood and electronically accept the ",
    de: "Ich habe das ",
    fr: "",
    ar: "",
    es: "I have read, understood and electronically accept the ",
  },
  "legal.consentMid": {
    tr: "'nu ve ",
    en: " and the ",
    de: " und den ",
    fr: " et ",
    ar: "لقد قرأت وفهمت وأوافق إلكترونياً على",
    es: " and the ",
  },
  "legal.consentPost": {
    tr: "'ni okudum, anladım ve elektronik ortamda onaylıyorum. ",
    en: ". ",
    de: " gelesen, verstanden und stimme elektronisch zu. ",
    fr: " J'ai lu, compris et approuve par voie électronique. ",
    ar: "و",
    es: ". ",
  },
  "legal.acceptPrefix": {
    tr: "",
    en: "I accept the ",
    de: "Ich akzeptiere die ",
    fr: "",
    ar: "",
    es: "I accept the ",
  },
  "legal.acceptPost": {
    tr: "'nı kabul ediyorum.",
    en: ".",
    de: ".",
    fr: " J'accepte.",
    ar: "أوافق على",
    es: ".",
  },
  "authErr.invalidCredentials": {
    tr: "E-posta/kullanıcı adı veya şifre hatalı.",
    en: "Incorrect email/username or password.",
    de: "E-Mail/Benutzername oder Passwort ist falsch.",
    fr: "E-mail/nom d'utilisateur ou mot de passe incorrect.",
    ar: "البريد الإلكتروني/اسم المستخدم أو كلمة المرور غير صحيحة.",
    es: "Correo/usuario o contraseña incorrectos.",
  },
  "authErr.emailNotConfirmed": {
    tr: "E-posta adresiniz henüz doğrulanmamış.",
    en: "Your email address is not confirmed yet.",
    de: "Deine E-Mail-Adresse ist noch nicht bestätigt.",
    fr: "Votre adresse e-mail n'est pas encore confirmée.",
    ar: "لم يتم تأكيد بريدك الإلكتروني بعد.",
    es: "Tu correo electrónico aún no está confirmado.",
  },
  "authErr.userNotFound": {
    tr: "Bu bilgilere ait bir hesap bulunamadı.",
    en: "No account found with these details.",
    de: "Kein Konto mit diesen Angaben gefunden.",
    fr: "Aucun compte trouvé avec ces informations.",
    ar: "لم يتم العثور على حساب بهذه البيانات.",
    es: "No se encontró ninguna cuenta con estos datos.",
  },
  "authErr.emailExists": {
    tr: "Bu e-posta adresi zaten kayıtlı.",
    en: "This email address is already registered.",
    de: "Diese E-Mail-Adresse ist bereits registriert.",
    fr: "Cette adresse e-mail est déjà enregistrée.",
    ar: "هذا البريد الإلكتروني مسجل بالفعل.",
    es: "Este correo electrónico ya está registrado.",
  },
  "authErr.rateLimit": {
    tr: "Çok fazla deneme yaptınız. Lütfen birkaç dakika sonra tekrar deneyin.",
    en: "Too many attempts. Please try again in a few minutes.",
    de: "Zu viele Versuche. Bitte versuche es in einigen Minuten erneut.",
    fr: "Trop de tentatives. Veuillez réessayer dans quelques minutes.",
    ar: "محاولات كثيرة جدًا. يُرجى المحاولة بعد بضع دقائق.",
    es: "Demasiados intentos. Inténtalo de nuevo en unos minutos.",
  },
  "authErr.weakPassword": {
    tr: "Şifre en az 6 karakter olmalı.",
    en: "Password must be at least 6 characters.",
    de: "Das Passwort muss mindestens 6 Zeichen haben.",
    fr: "Le mot de passe doit contenir au moins 6 caractères.",
    ar: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
    es: "La contraseña debe tener al menos 6 caracteres.",
  },
  "authErr.expiredLink": {
    tr: "Bağlantının süresi dolmuş veya geçersiz. Lütfen yeni bir bağlantı isteyin.",
    en: "The link has expired or is invalid. Please request a new one.",
    de: "Der Link ist abgelaufen oder ungültig. Bitte fordere einen neuen an.",
    fr: "Le lien a expiré ou est invalide. Veuillez en demander un nouveau.",
    ar: "انتهت صلاحية الرابط أو أنه غير صالح. يُرجى طلب رابط جديد.",
    es: "El enlace ha caducado o no es válido. Solicita uno nuevo.",
  },
  "authErr.invalidEmail": {
    tr: "Geçersiz e-posta adresi.",
    en: "Invalid email address.",
    de: "Ungültige E-Mail-Adresse.",
    fr: "Adresse e-mail invalide.",
    ar: "عنوان بريد إلكتروني غير صالح.",
    es: "Dirección de correo no válida.",
  },
  "authErr.network": {
    tr: "Bağlantı hatası. İnternetinizi kontrol edip tekrar deneyin.",
    en: "Connection error. Check your internet and try again.",
    de: "Verbindungsfehler. Prüfe deine Internetverbindung.",
    fr: "Erreur de connexion. Vérifiez votre connexion Internet.",
    ar: "خطأ في الاتصال. تحقق من الإنترنت وحاول مرة أخرى.",
    es: "Error de conexión. Comprueba tu internet e inténtalo de nuevo.",
  },
  "authErr.samePassword": {
    tr: "Yeni şifre eskisinden farklı olmalı.",
    en: "New password must be different from the old one.",
    de: "Das neue Passwort muss sich vom alten unterscheiden.",
    fr: "Le nouveau mot de passe doit être différent de l'ancien.",
    ar: "يجب أن تكون كلمة المرور الجديدة مختلفة عن القديمة.",
    es: "La nueva contraseña debe ser diferente de la anterior.",
  },
  "authErr.generic": {
    tr: "Bir hata oluştu. Lütfen tekrar deneyin.",
    en: "Something went wrong. Please try again.",
    de: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
    fr: "Une erreur est survenue. Veuillez réessayer.",
    ar: "حدث خطأ. يُرجى المحاولة مرة أخرى.",
    es: "Se produjo un error. Inténtalo de nuevo.",
  },
};
